/* eslint-disable react/no-array-index-key */
/** @jsxImportSource @emotion/react */
/** @jsxFrag */

import { ChangeEvent, memo } from "react";

import { RadioGroup as RadioGroupComp, FormControlLabel, Radio, Tooltip } from "@material-ui/core";

import { Label, Icon } from "..";

import { radio, radioWithBox, note as noteStyle, icon, iconTip as iconTipStyle } from "./styles";

interface RadioType {
  label: string;
  value: string;
  note?: string;
  disabled?: boolean;
  tooltip?: string;
  iconTip?: string;
}

interface Props {
  label?: string;
  tip?: string;
  name?: string;
  radios: RadioType[];
  value?: string;
  defaultValue?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  withBlock?: boolean;
}

// @ts-ignore
const Wire = ({ children, ...props }) => children(props);

const RadioGroup = ({
  label,
  tip,
  name,
  radios,
  defaultValue,
  value,
  onChange,
  disabled,
  withBlock = false,
}: Props): JSX.Element => {
  const renderRadios = (): JSX.Element[] =>
    radios.map(({ label: labelTxt, value: val, note, disabled: disabledEach, tooltip, iconTip }, i) => {
      const item = (
        <div key={`radio-${i}`} css={withBlock ? radioWithBox(3, value === val && !disabledEach) : radio(note ? 5 : 3)}>
          <FormControlLabel
            value={val}
            control={<Radio color="primary" disabled={disabled || disabledEach} />}
            label={labelTxt}
          />
          {iconTip && (
            <Tooltip css={iconTipStyle} title={iconTip} placement="right" interactive>
              <div css={icon}>
                <Icon name="exclamation-mark" fontSize="inherit" color="primary" />
              </div>
            </Tooltip>
          )}
          {note && <small css={noteStyle}>{note}</small>}
        </div>
      );

      return tooltip ? <Wire>{() => <Tooltip title={tooltip}>{item}</Tooltip>}</Wire> : item;
    });

  return (
    <>
      {label && <Label text={label} tip={tip} />}
      <RadioGroupComp name={name} row defaultValue={defaultValue || radios[0].value} value={value} onChange={onChange}>
        {renderRadios()}
      </RadioGroupComp>
    </>
  );
};

export default memo(RadioGroup);
